import React from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'

import Navbar from '../../templates/navbar/Navbar'
import * as ROLES from '../../../constants/roles'
import IfAnyGranted from '../../templates/route-management/IfAnyGranted'

const MainMenu = () => (
  <MainMenuLayout>
    <Navbar />
    <div className="container">
      <div className="section">
        <br />
        <h1 className="title">Main Menu</h1>
        <div className="columns">
          <IfAnyGranted roles={[ROLES.ADMIN, ROLES.SUPERVISOR]}>
            <div className="column">
              <Link to="/towns">
                <div className="card is-shady">
                  <div className="card-image has-text-centered">
                    <i className="fas fa-building" />
                  </div>
                  <div className="card-content">
                    <div className="content has-text-centered">
                      <h2>TOWN</h2>
                    </div>
                  </div>
                </div>
              </Link>
            </div>
          </IfAnyGranted>

          <div className="column">
            <Link to="/portals">
              <div className="card is-shady">
                <div className="card-image has-text-centered">
                  <i className="fas fa-home" />
                </div>
                <div className="card-content">
                  <div className="content has-text-centered">
                    <h2>PORTAL</h2>
                  </div>
                </div>
              </div>
            </Link>
          </div>
          <div className="column">
            <Link to="/mobile">
              <div className="card is-shady">
                <div className="card-image has-text-centered">
                  <i className="fas fa-pen-square" />
                </div>
                <div className="card-content">
                  <div className="content has-text-centered">
                    <h2>DRAFT</h2>
                  </div>
                </div>
              </div>
            </Link>
          </div>
        </div>
      </div>
    </div>
  </MainMenuLayout>
)

const MainMenuLayout = styled.div`
  .card-image > svg {
    font-size: 10rem;
    padding-top: 2rem;
    padding-bottom: 2rem;
    color: #209cee;
  }
`

export default MainMenu



// WEBPACK FOOTER //
// ./src/components/pages/web/MainMenu.js